export default __webpack_public_path__ + "static/media/freestanding.dc2b8207.svg";